import { CellProps } from "../cell-interface";
import { getTextDirectionAndAlignment } from "@common/utils/text-direction";

export default function TextScrollingCell({ cellValue }: CellProps) {
    const { direction, textAlign } = getTextDirectionAndAlignment(cellValue);

    return (
        <div
            style={{
                fontFamily: 'Inter, Assistant, sans-serif',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: "block",
                textAlign,
                fontSize: "14px",
                color: "#819ba8",
                padding: "0 10px",
                direction,
            }}
            dir={direction}>
            {cellValue}
        </div>
    );
}
